export enum DeviceStatus {
    PENDING = 'Pending',
    TRUSTED = 'Trusted',
    REJECTED = 'Rejected',
}
